import repository from "../Repository";

const inspectionResultList = "inspection/inspection-result-list";

export default {
  /**
   * 参照API
   * @param {*} screenId 画面ID
   * @param {*} payload ペイロード
   */
  async list(screenId, payload) {
    return await repository.post(`${inspectionResultList}`, payload, {
      headers: {
        s: screenId
      }
    });
  }
};
